

class ProductCard {
    constructor() {
      this.init();
    }
  
    init() {
      this.bindEvents();
      this.initializeExistingCards();
      this.watchForDynamicContent();
    }
  
    bindEvents() {
      document.addEventListener('mouseenter', (e) => {
        if (e.target.matches('.color-swatch--with-image')) {
          this.handleSwatchEnter(e.target);
        }
      }, true);
  
      document.addEventListener('mouseleave', (e) => {
        if (e.target.matches('.color-swatch--with-image')) {
          this.handleSwatchLeave(e.target);
        }
      }, true);
  
      document.addEventListener('click', (e) => {
        const swatch = e.target.closest('.grid-product .color-swatch[data-variant-id], .product-section.grid-product .color-swatch[data-variant-id]');
        if (swatch) {
          e.preventDefault();
          this.selectVariant(swatch);
          return;
        }

        const variantInput = e.target.closest('.grid-product .variant-input--small[data-variant-id], .product-section.grid-product .variant-input--small[data-variant-id]');
        if (variantInput) {
          e.preventDefault();
          this.selectVariant(variantInput);
          return;
        }

        if (e.target.matches('[class*="color-swatch-toggle--"]')) {
          const productId = this.extractProductIdFromToggle(e.target);
          if (productId) {
            this.toggleSwatches(productId);
          }
        }
      });

      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Enter' && e.key !== ' ') return;

        const swatch = e.target.closest('.grid-product .color-swatch[data-variant-id], .product-section.grid-product .color-swatch[data-variant-id]');
        if (swatch) {
          e.preventDefault();
          this.selectVariant(swatch);
        }
      });
    }

    getProductCard(element) {
      return element.closest('.grid-product, .product-section.grid-product');
    }

    formatMoney(cents) {
      if (window.theme && window.theme.Currency && window.theme.settings) {
        return window.theme.Currency.formatMoney(cents, window.theme.settings.moneyFormat);
      }

      return (cents / 100).toLocaleString(undefined, {
        style: 'currency',
        currency: 'SEK'
      });
    }

    selectVariant(element) {
      const card = this.getProductCard(element);
      if (!card || !element.dataset.variantId) return;

      const variantId = element.dataset.variantId;
      const variantSelect = card.querySelector('[data-product-select]');

      if (variantSelect) {
        variantSelect.value = variantId;
        variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }

      card.querySelectorAll('.color-swatch[data-variant-id], .variant-input--small[data-variant-id]').forEach((item) => {
        const isSelected = item.dataset.variantId === variantId;
        item.classList.toggle('color-swatch--selected', isSelected && item.classList.contains('color-swatch'));
        item.classList.toggle('variant-input--selected', isSelected && item.classList.contains('variant-input--small'));
        item.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });

      const variantTitle = element.dataset.variantTitle;
      const variantNameEl = card.querySelector('.variant__name');
      if (variantTitle && variantNameEl) {
        if (!variantNameEl.dataset.originalVariant) {
          variantNameEl.dataset.originalVariant = variantNameEl.textContent;
        }
        variantNameEl.textContent = variantTitle;
      }

      const image = element.dataset.variantImage;
      if (image) {
        const colorImageEl = card.querySelector('.grid-product__color-image--' + variantId);
        if (colorImageEl) {
          colorImageEl.style.backgroundImage = 'url(' + image + ')';
          colorImageEl.classList.add('is-active');
        }
      }

      const addToCartBtn = card.querySelector('[data-add-to-cart]');
      const priceEl = card.querySelector('[data-product-price]');
      const isAvailable = element.dataset.variantAvailable !== 'false';

      if (priceEl && element.dataset.variantPrice) {
        priceEl.textContent = this.formatMoney(parseInt(element.dataset.variantPrice, 10));
      }

      if (addToCartBtn) {
        addToCartBtn.disabled = !isAvailable;
      }
    }
  
    handleSwatchEnter(swatch) {
      const id = swatch.dataset.variantId;
      const image = swatch.dataset.variantImage;
      const variantTitle = swatch.dataset.variantTitle;
      const el = document.querySelector('.grid-product__color-image--' + id);
      
      if (el && image) {
        el.style.backgroundImage = 'url(' + image + ')';
        el.classList.add('is-active');
      }
      
      const productContainer = swatch.closest('.product-section, .grid-product, .product-card');
      if (productContainer) {
        const variantNameEl = productContainer.querySelector('.variant__name');
        if (variantTitle && variantNameEl) {
          if (!variantNameEl.dataset.originalVariant) {
            variantNameEl.dataset.originalVariant = variantNameEl.textContent;
          }
          variantNameEl.textContent = variantTitle;
        }
      }
    }
  
    handleSwatchLeave(swatch) {
      const id = swatch.dataset.variantId;
      const el = document.querySelector('.grid-product__color-image--' + id);
      
      if (el) {
        el.classList.remove('is-active');
      }
      
      const productContainer = swatch.closest('.product-section, .grid-product, .product-card');
      if (productContainer) {
        const variantNameEl = productContainer.querySelector('.variant__name');
        if (variantNameEl) {
          const originalVariantTitle = variantNameEl.dataset.originalVariant;
          if (originalVariantTitle) {
            variantNameEl.textContent = originalVariantTitle;
          }
        }
      }
    }
  
    toggleSwatches(productId, totalCount = null) {
      const container = document.querySelector('.grid-product__colors--' + productId);
      if (!container) return;
      
      const hiddenSwatches = container.querySelectorAll('.color-swatch--hidden');
      const toggle = container.querySelector('.color-swatch-toggle--' + productId);
      
      if (!toggle || !hiddenSwatches.length) return;
      
      const plusIcon = toggle.querySelector('.toggle-plus');
      const minusIcon = toggle.querySelector('.toggle-minus');
      
      const firstHidden = hiddenSwatches[0];
      const isCurrentlyHidden = !firstHidden.style.display || firstHidden.style.display === 'none';
      
      hiddenSwatches.forEach(swatch => {
        swatch.style.display = isCurrentlyHidden ? 'inline-block' : 'none';
      });
      
      if (isCurrentlyHidden) {
        plusIcon.style.display = 'none';
        minusIcon.style.display = 'inline';
        toggle.setAttribute('aria-label', 'Show fewer colors');
      } else {
        plusIcon.style.display = 'inline';
        minusIcon.style.display = 'none';
        toggle.setAttribute('aria-label', 'Show more colors');
      }
    }
  
    extractProductIdFromToggle(toggleElement) {
      const classes = toggleElement.className.split(' ');
      for (let className of classes) {
        if (className.startsWith('color-swatch-toggle--')) {
          return className.replace('color-swatch-toggle--', '');
        }
      }
      return null;
    }
  
    initializeExistingCards() {
      const productCards = document.querySelectorAll('.grid-product, .product-card, .product-section');
      productCards.forEach(card => this.initializeCard(card));
    }
  
    initializeCard(cardElement) {
      const variantNameEl = cardElement.querySelector('.variant__name');
      if (variantNameEl && !variantNameEl.dataset.originalVariant) {
        variantNameEl.dataset.originalVariant = variantNameEl.textContent;
      }
    }
  
    watchForDynamicContent() {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.addedNodes.length > 0) {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === 1) { // Element node
                const productCards = node.matches && node.matches('.grid-product, .product-card, .product-section') 
                  ? [node] 
                  : node.querySelectorAll ? node.querySelectorAll('.grid-product, .product-card, .product-section') 
                  : [];
                
                productCards.forEach(card => this.initializeCard(card));
              }
            });
          }
        });
      });
  
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  
    static initializeCards(selector = '.grid-product, .product-card, .product-section') {
      const cards = document.querySelectorAll(selector);
      cards.forEach(card => {
        const instance = new ProductCard();
        instance.initializeCard(card);
      });
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      window.productCardInstance = new ProductCard();
    });
  } else {
    window.productCardInstance = new ProductCard();
  }
  
  window.toggleSwatches = function(productId, totalCount) {
    if (window.productCardInstance) {
      window.productCardInstance.toggleSwatches(productId, totalCount);
    }
  };
  
  window.ProductCard = ProductCard;